module.exports = __webpack_public_path__ + "static/media/Clover_Legacy_188-2.1cd1d68d.jpg";